import * as Highcharts from 'highcharts'
import * as HighMaps from 'highcharts/highmaps'

//Apply Charts theme
Highcharts.setOptions({
  chart: {
    style: { fontFamily: '"Roboto", Arial, sans-serif' }
  }
})

//Reflow highcharts for better usage with responsive frameworks (fix responsive overflow)
const responsiveReflow = (newChart: Highcharts.ChartObject) => {
  setTimeout(() => {
    try { newChart.reflow() } catch (atLeastWeTried) { /**/ }
  }, 1000)
}

Highcharts.Chart.prototype.callbacks.push(responsiveReflow)
HighMaps.Chart.prototype.callbacks.push(responsiveReflow)



// WEBPACK FOOTER //
// ./src/app/components/data/DataChart/config.ts